import { Controller } from "stimulus"

// Polls for AI response in learning threads since Turbo Streams
// may not be ready when the response is broadcast
export default class extends Controller {
  static values = {
    threadId: String
  }

  connect() {
    this.isPolling = true

    // Start polling for assistant response
    this.pollInterval = setInterval(() => {
      this.pollForMessages()
    }, 1500)

    // Stop polling after 60 seconds
    this.maxTimeout = setTimeout(() => {
      this.stopPolling()
    }, 60000)

    // Stop polling when user clicks any button (they're navigating away)
    this.boundStopOnClick = this.stopOnNavigation.bind(this)
    document.addEventListener('submit', this.boundStopOnClick)
  }

  disconnect() {
    this.stopPolling()
    if (this.boundStopOnClick) {
      document.removeEventListener('submit', this.boundStopOnClick)
    }
  }

  stopOnNavigation(event) {
    // Stop polling immediately when any form is submitted
    this.stopPolling()
  }

  stopPolling() {
    this.isPolling = false
    if (this.pollInterval) {
      clearInterval(this.pollInterval)
      this.pollInterval = null
    }
    if (this.maxTimeout) {
      clearTimeout(this.maxTimeout)
      this.maxTimeout = null
    }
  }

  async pollForMessages() {
    // Don't poll if we've stopped
    if (!this.isPolling) return

    // If we already have an assistant message, stop polling
    const assistantMessages = this.element.querySelectorAll('.msg-assistant')
    if (assistantMessages.length > 0) {
      this.stopPolling()
      return
    }

    if (!this.threadIdValue) return

    try {
      const response = await fetch(`/chats/threads/${this.threadIdValue}/messages.json`, {
        headers: {
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        credentials: 'same-origin'
      })

      if (response.ok && this.isPolling) {
        const data = await response.json()
        if (data.has_assistant && this.isPolling) {
          // Replace the messages container with new content
          const messagesContainer = this.element.querySelector('#list-messages')
          if (messagesContainer && data.messages_html) {
            messagesContainer.innerHTML = data.messages_html
          }
          this.stopPolling()
        }
      }
    } catch (error) {
      console.error('Error polling for messages:', error)
    }
  }
}
